export class XeroHttp {
    /**
     * Get xero services
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getServices() {
        try {
            return await window.axios.get(`xero/services`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get xero categories
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getCategories() {
        try {
            return await window.axios.get(`xero/categories`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get xero accounts
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getAccounts() {
        try {
            return await window.axios.get(`xero/accounts`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get an invoice
     * @param id
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async getInvoice(id) {
        try {
            return await window.axios.get(`xero/invoice/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Approve send booking
     * @param id
     * @param booking
     * @return {Promise<AxiosResponse<any>>}
     */
    static async approveSendBooking(id, booking) {
        try {
            return await window.axios.post(`xero/invoice/${id}/approve`, {booking: booking});
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get customer if exists
     * @param email
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async findCustomer(email) {
        try {
            return await window.axios.get(`xero/customer/${email}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Create a new customer
     * @param customer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createCustomer(customer) {
        try {
            return await window.axios.post(`xero/customer`, customer);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Create a Xero Invoice
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async createInvoice(booking) {
        try {
            return await window.axios.post(`xero/invoice`, booking);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Split an invoice
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async splitInvoice(booking) {
        try {
            return await window.axios.post(`xero/invoice/split`, booking);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Update an invoice
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateInvoice(booking) {
        try {
            return await window.axios.put(`xero/invoice`, booking);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Update a customer
     * @param customer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateCustomer(customer) {
        try {
            return await window.axios.put(`xero/customer`, customer);
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
